export class HeaderField {
   label:string;
   colSpan:number;

   constructor(field:any) {
      this.label = field.label;
      this.colSpan = field.colSpan;
   }
}
